import React, { useState, useEffect } from 'react';
import axiosInstance from '../services/axiosInstance';

export function useDuplicateHandling() {
  const [duplicateAssetIds, setDuplicateAssetIds] = useState<Set<string>>(new Set());
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateModalAssetId, setDuplicateModalAssetId] = useState<string | null>(null);
  const [duplicateClusterData, setDuplicateClusterData] = useState<any>(null);
  const [duplicateClusterLoading, setDuplicateClusterLoading] = useState(false);
  const [duplicateModalSelectedA, setDuplicateModalSelectedA] = useState<string | null>(null);
  const [duplicateModalSelectedB, setDuplicateModalSelectedB] = useState<string | null>(null);
  const [duplicateMerging, setDuplicateMerging] = useState(false);
  const [duplicateMergeDialogOpen, setDuplicateMergeDialogOpen] = useState(false);

  useEffect(() => {
    const fetchDuplicateIds = async () => {
      try {
        const response = await axiosInstance.get('/api/duplicates/asset-ids-with-duplicates');
        if (response.data?.assetIds) {
          setDuplicateAssetIds(new Set(response.data.assetIds));
        }
      } catch (err) {
        console.error('Failed to fetch duplicate asset IDs:', err);
      }
    };
    fetchDuplicateIds();
  }, []);

  const handleDuplicateIndicatorClick = async (e: React.MouseEvent, assetId: string) => {
    e.stopPropagation();
    e.preventDefault();
    setDuplicateModalAssetId(assetId);
    setDuplicateModalSelectedA(assetId);
    setDuplicateModalSelectedB(null);
    setDuplicateModalOpen(true);
    setDuplicateClusterLoading(true);
    try {
      const response = await axiosInstance.get(`/api/duplicates/cluster-for-asset/${assetId}`);
      setDuplicateClusterData(response.data?.cluster || null);
    } catch (err) {
      console.error('Failed to fetch duplicate cluster:', err);
      setDuplicateClusterData(null);
    } finally {
      setDuplicateClusterLoading(false);
    }
  };

  return {
    duplicateAssetIds, setDuplicateAssetIds,
    duplicateModalOpen, setDuplicateModalOpen,
    duplicateModalAssetId, setDuplicateModalAssetId,
    duplicateClusterData, setDuplicateClusterData,
    duplicateClusterLoading,
    duplicateModalSelectedA, setDuplicateModalSelectedA,
    duplicateModalSelectedB, setDuplicateModalSelectedB,
    duplicateMerging, setDuplicateMerging,
    duplicateMergeDialogOpen, setDuplicateMergeDialogOpen,
    handleDuplicateIndicatorClick,
  };
}
